import ecom from '../../assets/industry/ecommerce.png'
import law from '../../assets/industry/law.png'
import blog from '../../assets/industry/blog.png'
import doctor from '../../assets/industry/doctor.png'
import fastfood from '../../assets/industry/fast-food.png'
import hospital from '../../assets/industry/hospital.png'
import realstate from '../../assets/industry/real-state.png'
import school from '../../assets/industry/education.png'
import service from '../../assets/industry/services.png'
// import software from '../../assets/industry/software-engineering.png'
import production from '../../assets/industry/production.png'
import logistics from '../../assets/industry/logistics.png'
import software from '../../assets/industry/software.png'

const indestry =()=>{
    return(
        <>
            <div className="container-fluid">
                <div className="container p-5 industryMobile">
                    <p style={{ color: "#0c0c0cff" }}>Industry</p>
                    <h2
                        style={{
                        color: "#3e13c0ff",
                        fontWeight: "500",
                        fontFamily: "Bungee, sans-serif",
                        }}
                    >
                        Industries We Served
                    </h2>

                    {/* First Row */}
                    <div className="row m-3 mt-5">
                        <div className="col-6 col-md-2 industry">
                        <img src={ecom} alt="ecommerce" className="img-fluid" />
                        <p>E-Commerce</p>
                        </div>
                        <div className="col-6 col-md-2 industry">
                        <img src={realstate} alt="realstate" className="img-fluid" />
                        <p>Real Estate</p>
                        </div>
                        <div className="col-6 col-md-2 industry">
                        <img src={blog} alt="blogging" className="img-fluid" />
                        <p>Blogging</p>
                        </div>
                        <div className="col-6 col-md-2 industry">
                        <img src={service} alt="support" className="img-fluid" />
                        <p>Support</p>
                        </div>
                        <div className="col-6 col-md-2 industry">
                        <img src={fastfood} alt="food" className="img-fluid" />
                        <p>Food & Beverage</p>
                        </div>
                        <div className="col-6 col-md-2 industry">
                        <img src={school} alt="school" className="img-fluid" />
                        <p>Edu Institutes</p>
                        </div>
                    </div>

                    {/* Second Row */}
                    <div className="row m-3">
                        <div className="col-6 col-md-2 industry">
                        <img src={doctor} alt="doctor" className="img-fluid" />
                        <p>Doctor</p>
                        </div>
                        <div className="col-6 col-md-2 industry">
                        <img src={law} alt="law" className="img-fluid" />
                        <p>Law</p>
                        </div>
                        <div className="col-6 col-md-2 industry">
                        <img src={production} alt="production" className="img-fluid" />
                        <p>Production Line</p>
                        </div>
                        <div className="col-6 col-md-2 industry">
                        <img src={logistics} alt="logistics" className="img-fluid" />
                        <p>Logistics</p>
                        </div>
                        <div className="col-6 col-md-2 industry">
                        <img src={hospital} alt="hospital" className="img-fluid" />
                        <p>Hospital</p>
                        </div>
                        <div className="col-6 col-md-2 industry">
                        <img src={software} alt="software" className="img-fluid" />
                        <p>Software</p>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
export default indestry